import React, { CSSProperties } from 'react';
import styled from 'styled-components';

const StyledContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  height: 25px;
  margin-bottom: 5px;
`;
const StyledLabel = styled.label`
  width: 140px;
  flex-shrink: 0;
  color: ${props => props.theme.colors.black};
  font-size: inherit;
`;
const StyledSlider = styled.input`
  appearance: none;
  color: ${props => props.theme.colors.black};
  background: linear-gradient(
    to right,
    ${props => props.theme.colors.focusRing} 0%,
    ${props => props.theme.colors.focusRing} var(--fill, 0%),
    ${props => props.theme.colors.borderSubtle} var(--fill, 0%),
    ${props => props.theme.colors.borderSubtle} 100%
  );
  border: 1px solid ${props => props.theme.colors.borderSubtle};
  box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.1);
  width: 100%;
  height: 8px;
  border-radius: 4px;
  cursor: pointer;
  transition:
    background 0.1s,
    box-shadow 0.2s;

  &:hover:not([disabled]) {
    box-shadow: inset 0 1px 3px rgba(0, 0, 0, 0.15);
  }

  &:focus-visible {
    outline: 2px solid ${props => props.theme.colors.focusRing};
    outline-offset: 3px;
  }

  &:disabled {
    background: linear-gradient(
      to right,
      ${props => props.theme.colors.midGrey} 0%,
      ${props => props.theme.colors.midGrey} var(--fill, 0%),
      ${props => props.theme.colors.lightGrey} var(--fill, 0%),
      ${props => props.theme.colors.lightGrey} 100%
    );
    cursor: not-allowed;
  }

  &::-webkit-slider-thumb {
    appearance: none;
    width: 18px;
    height: 18px;
    border-radius: 50%;
    background-color: ${props => props.theme.colors.focusRing};
    border: 2px solid ${props => props.theme.colors.white};
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
    cursor: pointer;
  }

  &::-moz-range-thumb {
    appearance: none;
    width: 18px;
    height: 18px;
    border-radius: 50%;
    background-color: ${props => props.theme.colors.focusRing};
    border: 2px solid ${props => props.theme.colors.white};
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
    cursor: pointer;
  }
`;

const StyledInput = styled.input`
  display: inline-block;
  background-color: ${props => props.theme.colors.white};
  border-radius: 0;
  appearance: none;
  color: ${props => props.theme.colors.black};
  font-family: inherit;
  font-size: inherit;
  line-height: inherit;
  border: 1px solid ${p => p.theme.colors.grey};
  width: 80px;
  margin-right: auto;
  border: 0;
  text-align: center;

  &:active:not([disabled]),
  &:focus:not([disabled]),
  &:hover:not([disabled]) {
    // border: 1px solid ${p => p.theme.colors.deepGrey};
  }

  &[disabled] {
    color: ${p => p.theme.colors.midGrey};
  }
`;

export const CustomVMSlider = ({ labelText, ...props }: any) => {
  const min = Number(props.min ?? 0);
  const max = Number(props.max ?? 100);
  const value = Number(props.value ?? min);
  const fillPercent = max > min ? ((value - min) / (max - min)) * 100 : 0;

  return (
    <StyledContainer>
      <StyledLabel>{labelText}</StyledLabel>
      <StyledSlider
        type="range"
        {...props}
        style={{ '--fill': `${fillPercent}%` } as React.CSSProperties}
      />
      <StyledInput name="value" type="number" {...props} />
    </StyledContainer>
  );
};
